import api from './api'

export default {
  createOrUpdate(params) {
    return api.post(`admin/address`, params)
  },
}
